require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-simple-sprite-kit-tutorial-in-swift-part-1.json") })
        }
      }, "path---blog-simple-sprite-kit-tutorial-in-swift-part-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-simple-sprite-kit-tutorial-in-swift-part-1!./.cache/json/blog-simple-sprite-kit-tutorial-in-swift-part-1.json
// module id = 1090
// module chunks = 231608221292675